import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

function usePreview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isPreview, setIsPreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [environment, setEnvironment] = useState('');

  const segments = pathname?.slice(1).split('/') || [];
  const slug = segments[segments.length - 1] || 'home';
  const path = segments.slice(0, -1).join('/');
  const env = searchParams?.get('env') || '';

  const previewParams = new URLSearchParams({
    // Bypass secret checking
    client: 'trusted',
    slug,
    path,
    env,
  });

  useEffect(() => {
    const fetchPreviewStatus = async () => {
      setIsLoading(true);
      const res = await fetch('/api/preview-status');
      const data = await res.json();
      setIsPreview(data.isPreview);
      setEnvironment(data.previewData.env || 'master');
      setIsLoading(false);
    };
    fetchPreviewStatus();
  }, []);

  const handlePreview = () => {
    // Keep loading state until the redirect is complete
    setIsLoading(true);

    const searchParamsString = searchParams?.toString();
    const redirectUrl = searchParamsString
      ? `${pathname}?${searchParamsString}`
      : pathname;

    if (isPreview) {
      window.location.href = `/api/exit-preview?redirect=${redirectUrl}`;
    } else {
      window.location.href = `/api/preview?${previewParams.toString()}`;
    }
  };

  return { environment, isPreview, handlePreview, isLoading };
}

export default usePreview;
